import { render, staticRenderFns } from "./LanguageSwitcherFooter.vue?vue&type=template&id=466e8659&scoped=true&"
import script from "./LanguageSwitcherFooter.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcherFooter.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcherFooter.vue?vue&type=style&index=0&id=466e8659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e8659",
  null
  
)

export default component.exports